import { useState } from 'react';

// Заглушка, если фото не загрузилось: иконка на тёмно-зелёном фоне
export function EventPhoto({ src, alt, className = '', placeholderClassName = '' }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`flex items-center justify-center bg-[#0D3326] ${className} ${placeholderClassName}`}
        aria-label={alt || 'Фото недоступно'}
      >
        <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
          <path
            d="M21 5H3C1.9 5 1 5.9 1 7V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V7C23 5.9 22.1 5 21 5ZM21 19.01H3V6.99H21V19.01ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM5 16H15V12L12.03 14.71L9.5 12.25L5 16.5V16ZM16 16H19V10.6L16.47 13.13L16 13V16Z"
            fill="#A1F69E"
          />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      draggable={false}
    />
  );
}
